import { Box, Button, Grid, Typography } from "@mui/material";
import { useRef } from "react";
import ImageIcon from '@mui/icons-material/Image';

const UploadImage = ({ images, setImages, setPreviews, mostrarErrorRequest, messageLimit = false, 
    setUploadImageDialog = undefined, minimo = 2, max = 20, textBotton = 'Cargar imágenes' }) => {

    const fileInputRef = useRef(null);

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        setPreviews([]);
        setImages([]);
        const files = Array.from(event.target.files);

        if (files.length < minimo || files.length > max) {
            mostrarErrorRequest(`Debes seleccionar entre ${minimo} y ${max} imágenes.`);
            return;
        }

        const processedImages = await Promise.all(
            files.map(file => resizeImageWithCanvas(file, 0.8)) // calidad entre 0 y 1
        );

        // Separa la parte base64 para enviar
        const base64Strings = processedImages.map((dataUrl) => dataUrl.split(',')[1]);

        setPreviews(processedImages); // para mostrar en <img />
        setImages(base64Strings);     // para enviar al backend

        if(setUploadImageDialog !== undefined) {
            setUploadImageDialog(true);
        }
    };

    const resizeImageWithCanvas = (file, quality = 0.8, maxWidth = 1920, maxHeight = 1080) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    // Redimensionar si es necesario
                    let { width, height } = img;
                    if (width > maxWidth || height > maxHeight) {
                        const scale = Math.min(maxWidth / width, maxHeight / height);
                        width *= scale;
                        height *= scale;
                    }

                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // Comprimir a JPEG con calidad
                    const dataUrl = canvas.toDataURL('image/jpeg', quality); // calidad entre 0 y 1
                    resolve(dataUrl);
                };
                img.onerror = reject;
                img.src = event.target.result;
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    return (
        <Grid item container alignItems="center" spacing={2}>
            <Grid item xs={12}>
                {messageLimit&&<Typography variant="subtitle1" gutterBottom>
                    Seleccione las imágenes
                </Typography>}

                <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<ImageIcon />}
                    onClick={handleClick}
                    sx={{ mb: 1 }}
                >
                    {textBotton}
                </Button>
                <input
                    type="file"
                    accept="image/*"
                    multiple
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />

                {messageLimit && images.length < minimo && (
                    <Box color="error.main" mt={1}>
                        Se requiere como mínimo {minimo} imágenes
                    </Box>
                )}
            </Grid>
        </Grid>
    )
}

export default UploadImage;